import {isMobile} from './commonMethods';
import {globalImport} from '../common/globalImports';
import {Color} from '../assets';
import {
  account_profile,
  account_raiseTicket,
  account_refer,
  account_support,
  account_telegram,
  back_arrow,
  cancel_black,
  close,
  coin,
  cross_new,
  down_arrow,
  event_about,
  gift,
  home_sort,
  ic_minus,
  ic_plus,
  info,
  left_arrow_black,
  logoName,
  markets_empty,
  marketTab10,
  marketTab_selected10,
  nothing_card_closed,
  nothing_card_live,
  portfolio_empty,
  portfolioTab10,
  portfolioTab_selected10,
  right_arrow,
  right_arrow_black,
  tick_new,
  tip_image,
  transactions_add,
  transactions_invest,
  transactions_withdraw,
  up_arrow,
  walletTab10,
  walletTab_selected10,
  warning,
  WhatsApp,
  howToPlay10,
  howToPlay10_selected,
} from './images';
import Colors from '../assets/Color/Colors';
import {globalConfigurableData} from './globalConstant';

export const BottomTabThemeMyMaster = {
  tabSelectedColor: Color.bgWhite,
  tabUnselectedColor: Color.mgrey,
  tabBottomBarColor: Color.mblue,
  tabTextData: [
    {
      iconSelected: '',
      tabLabel: 'Markets',
      isVisible: '',
    },
    {
      iconSelected: '',
      tabLabel: 'Portfolio',
      isVisible: '',
    },
    {
      iconSelected: '',
      tabLabel: 'Fantasy',
      isVisible: false,
    },
    {
      iconSelected: '',
      tabLabel: 'Transactions',
      isVisible: true,
    },
    {
      iconSelected: '',
      tabLabel: 'Account',
      isVisible: false,
    },
    {
      iconSelected: '',
      tabLabel: 'How To Play?',
      isVisible: true,
    },
  ],
};

export const bottomIconThemeMyMaster = {
  iconConfig: {
    market: marketTab10(),
    wallet: walletTab10(),
    portfolio: portfolioTab10(),
    howToPlay: howToPlay10()
  },
  iconSelectedConfig: {
    market: marketTab_selected10(),
    wallet: walletTab_selected10(),
    portfolio: portfolioTab_selected10(),
    howToPlay: howToPlay10_selected()
  },
};

export const globalConfigurableDataMyMaster = {
  appName: 'My Master 11',
  isMobileViewInDesktop: false,
  switchTabSelectedColor: Colors.black,
  switchTabUnselectedColor: Colors.lightgrey,
  switchTabUnselectedBorderColor: Colors.borderColor,
  newSwitchTabBgColor: 'rgba(244, 244, 244, 1)',
  newSwitchTabSelectedBgColor: Colors.bgWhite,
  cardBgColor: Colors.bgWhite,
  logoUrl: logoName,
  globalThemeColor: Color.bgWhite,
  fontColor: '',
  primaryTextColor: Color.black,
  secondaryTextColor: Color.bgWhite,
  tertiaryTextColor: '',
  headerColor: Color.bgWhite,
  primaryTextColor1: Color.black,
  secondaryTextColor1: Color.lightgrey,
  tertiaryTextColor1: Color.grey,
  quaternaryTextColor1: Color.grey1,
  contrastTextColor1: Color.bgWhite,
  alternateTextColor: Colors.bgWhite,
  errorTextColor1: Color.red,
  profitColor: Colors.green,
  lossColor: Colors.red,
  borderColor: Colors.borderColor,
  yesBtnBlock: 'rgba(39, 174, 96, 1)',
  noBtnBlock: 'rgba(245, 56, 56, 1)',
  noBtnTxt: Colors.bgWhite,
  yesBtnTxt: Colors.bgWhite,
  loaderColor: Colors.black,
  disableBtnColor: Colors.bgWhite,
  disableBtnTextColor: Colors.black,
  yesBtnBlockInactive: 'rgba(39, 174, 96, 0.1)',
  noBtnBlockInactive: 'rgba(245, 56, 56, 0.1)',
  yesBtnBlockInactiveTxt: 'rgba(39, 174, 96, 1)',
  noBtnBlockInactiveTxt: 'rgba(245, 56, 56, 1)',
  primaryBtnColor: Color.mblue,
  secondaryBtnColor: Color.black,
  primaryBtnTxt: Colors.bgWhite,
  greyBtnColor: Color.grey4,
  greyBtnTxt: Colors.black,
  btnBorderRadius: 8,
  imageBgColor: Color.lightgrey1,
  sortIcon: home_sort,
  back_arrow: back_arrow,
  cancel_black: cancel_black,
  close: close,
  cross_new: cross_new,
  down_arrow: down_arrow,
  event_about: event_about,
  gift: gift,
  info: info,
  right_arrow: right_arrow,
  tick_new: tick_new,
  transactions_add: transactions_add,
  transactions_invest: transactions_invest,
  transactions_withdraw: transactions_withdraw,
  up_arrow: up_arrow,
  warning: warning,
  WhatsApp: WhatsApp,
  tooltip: tip_image,
  right_arrow_black: right_arrow_black,
  left_arrow_black: left_arrow_black,
  ic_plus: ic_plus,
  ic_minus: ic_minus,
  nothing_card_live: nothing_card_live,
  nothing_card_closed: nothing_card_closed,
  coin: coin,
  markets_empty: markets_empty,
  portfolio_empty: portfolio_empty,
  initFunction: () => {},
};

export const GlobalScreensThemeMyMaster = {
  Home: {
    isShowBanner: false,
    howToTrade: true,
    isShowDefaultBanner: true,
    categorySelectedBgColor: Color.black,
    subCategorySelectedBgColor: Color.mblue,
    categoryUnselectedBgColor: Color.grey4,
    categorySelectedBorderColor: Color.black,
    categoryUnselectedColor: Color.black,
    categoryBorder: 0,
    categorySelectedColor: Color.bgWhite,
    dropdownBgColor: Color.grey4,
    dropdownRadioBtnColor: Colors.black,
    tradeCardBgColor: Colors.bgWhite,
    hashTagTitleColor: Colors.black,
    hashTagBgColor: Color.grey4,
    yesBtnBlock: 'rgba(39, 174, 96, 0.10)',
    noBtnBlock: 'rgba(245, 56, 56, 0.10)',
    noBtnTxt: Colors.mNoColor,
    yesBtnTxt: Colors.mYesColor,
    mCardBorder: 'rgba(228, 228, 228, 0.6)',
    hideHomeHeader: true,
    showLoaderHome: false,
  },
  Portfolio: {
    cardBgColor: Colors.grey4,
    borderColor: 'rgba(228, 228, 228, 0.8)',
    yesBtnBorder: 'rgba(39, 174, 96, 1)',
    noBtnBorder: 'rgba(245, 56, 56, 1)',
    yesBtnBlock: 'rgba(39, 174, 96, 0.1)',
    noBtnBlock: 'rgba(245, 56, 56, 0.1)',
    noBtnTxt: 'rgba(245, 56, 56, 1)',
    yesBtnTxt: 'rgba(39, 174, 96, 1)',
    btnBorderRadius: 5,
    summaryBox: Colors.grey4,
  },
  Event: {
    cardBgColor: Colors.bgWhite,
    borderColor: 'rgba(228, 228, 228, 0.8)',
    isShowEventShare: '',
    yesBtnBlock: 'rgba(39, 174, 96, 0.1)',
    noBtnBlock: 'rgba(245, 56, 56, 0.1)',
    noBtnTxt: 'rgba(245, 56, 56, 1)',
    yesBtnTxt: 'rgba(39, 174, 96, 1)',
    tipColor: Color.black,
    tipBackgroundColor: Color.grey4,
    InvestedBox: 'rgba(27, 42, 133, 0.1)',
    InvestedTxt: Colors.mblue,
    StatsBlock: Colors.grey4,
    isShowBalanceInPopUp: false,
  },
  SingleOrder: {
    switchTabSelectedColor: Colors.yesColor,
    switchTabUnselectedColor: Colors.grey,
    switchTabUnselectedBorderColor: Colors.bgWhite,
    highlightColor: Colors.mblue,
    switchSliderSelectedColor: Colors.black,
    switchSliderUnselectedColor: 'rgba(27, 42, 133, 0.1)',
    radioBorder: Colors.black,
    inputColor: Colors.bgWhite,
  },
  Wallet: {
    cardBgColor: Colors.bgWhite,
    highlightColor: Colors.mblue,
    transactionBox: Colors.grey5,
    isShowAddWallet: '',
    isShowWithdrawWallet: '',
    isShowFAQ: '',
    isShowKYCStatus: '',
    isShowCouponCodeAddMoney: '',
    walletSummaryBtnColor: Colors.black,
    partnerPopUp: false,
  },
  AddMoney: {
    borderColor: Colors.black,
    disclaimerBgColor: 'rgba(27, 42, 133, 0.1)',
    disclaimerConfigBgColor: '#F5F7F9',
  },
  Account: {
    googleTheme: 'outline',
    partnerLogin: false,
    showAccount: true,
    imgBgColor: '#F5F5F5',
    isKyc: true,
    listOptions: [
      {
        img: account_profile,
        title: 'My Profile',
        subtitle: 'Manage your profile & KYC details here',
        redirect: 'profile',
      },
      {
        img: account_profile,
        title: 'Clubs',
        subtitle: 'Get access to exclusive events',
        redirect: 'clubsList',
      },
      {
        img: account_refer,
        title: 'Invite & Earn',
        subtitle: 'Earn friends & earn 25% cashback of their trading fee.',
        redirect: 'refer',
      },
      {
        img: account_refer,
        title: 'Choose Language',
        subtitle: 'Choose your preferred language',
        redirect: 'LanguageSelection',
      },
      {
        img: account_telegram,
        title: 'Join Telegram',
        subtitle: 'Join our telegram channel & get latest updates',
        redirect: 'telegram',
      },
      {
        img: account_raiseTicket,
        title: 'Frequently Asked Questions',
        subtitle: 'Get answers to the most questions here',
        redirect: 'zendesk',
      },
      {
        img: account_support,
        title: 'Raise a Ticket',
        subtitle: 'In case of any issues, you can contact us instantly',
        redirect: 'RT',
      },
    ],
  },
  TxnPage: {
    creditAmtColor: '',
    debitAmtColor: '',
    isShowBackIcon: false,
    borderBottomWidth: 0.5,
    borderBottomColor: Color.mgrey1,
    txnTitle: 'Transactions',
    txnLimit: 20,
  },
};
